import { Component, ComponentFactoryResolver, Input, OnInit, ViewChild } from '@angular/core';
import { ProductsContainerDirective } from 'src/app/global/directives/products-container/products-container.directive';
import { Product } from 'src/app/view-model/components/shopping-cart/product';
import { ProductAttacher } from 'src/app/view-model/components/shopping-cart/product-attacher';

@Component({
  selector: 'app-products-wrapper',
  templateUrl: './products-wrapper.component.html',
  styleUrls: ['./products-wrapper.component.scss']
})
export class ProductsWrapperComponent implements OnInit {

  @Input() products: Product[] = [];

  @ViewChild(ProductsContainerDirective, { static: true }) productContainer: ProductsContainerDirective;

  constructor(private componentFactoryResolver: ComponentFactoryResolver) { }

  ngOnInit(): void {
    const productAttacher = new ProductAttacher(this.componentFactoryResolver, this.productContainer.viewContainerRef);
    productAttacher.addProducts(this.products);
  }


}
